export default __webpack_public_path__ + "static/media/KursRaum.d4b26340.jpg";